import React, { useEffect, useState } from "react";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import ListLayout from "../../../../../partials/content/ListLayout";
import { getIncomingInvoiceDetail } from "../../../../../services/finance/incomingInvoice";
import IncomingInvoiceBasicInfo from "./incomingInvoiceBasicInfo";
import IncomingInvoicePayments from "./incomingInvoicePayments";
import Notes from "../../../common/notes";
import Attachments from "../../../common/attachments";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
function IncomingInvoiceDetail({ match, history }) {
  const { reload } = useGlobalData();
  const invoiceID = match.params.invoiceID;
  const [invoice, setInvoice] = useState({
    ID: 0,
    vendor: {
      vendorName: "",
    },
  });
  const [approvalProcess, setApprovalProcess] = useState([]);
  const [approvalSteps, setApprovalSteps] = useState([]);
  const [approvalActiveStep, setApprovalActiveStep] = useState(0);
  const [component, setComponent] = useState(null);
  const [headerTitle, setHeaderTitle] = useState("Basic Info");
  const [listMenu, setListMenu] = useState([
    {
      key: "basicInfo",
      label: "Basic Info",
      icon: "fas fa-th-large",
    },
    {
      key: "payments",
      label: "A/P Payments",
      icon: "fas fa-money-check-alt",
    },
    {
      key: "attachments",
      label: "Attachments",
      icon: "fas fa-paperclip",
    },
    {
      key: "notes",
      label: "Notes",
      icon: "fas fa-sticky-note",
    },
  ]);

  const defaultSelected = "basicInfo";

  useEffect(() => {
    getIncomingInvoiceData(invoiceID);
  }, [invoiceID, reload]);

  const actionButtons = [
    {
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/finance/invoices/AP");
      },
    },
  ];
  if (
    invoice.edit &&
    (invoice.approvalProcessID === 0 ||
      invoice.approvalProcess.statusID === 2 ||
      invoice.approvalProcess.statusID === 3) &&
    invoice.paymentStatus === 1
  ) {
    actionButtons.push({
      title: "Edit A/P Invoice",
      color: "primary",
      icon: "fas fa-edit",
      onClick: () => {
        history.push("/finance/edit-incoming-invoice/" + invoiceID);
      },
    });
  }

  return (
    <React.Fragment>
      <PageSubHeader
        title={headerTitle ? headerTitle : "Basic Info"}
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/finance/invoices/AP",
            title: "Invoices",
            active: false,
          },
          {
            page: "/finance/incoming-invoice-detail/" + invoiceID,
            title: "A/P Invoice ID " + invoice.incomingInvoiceCode,
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <ContentLayout>
        <ListLayout
          component={component}
          listMenu={listMenu}
          onSelectItem={(key) => {
            let selectedComponent;
            switch (key) {
              case "basicInfo":
                selectedComponent = (
                  <IncomingInvoiceBasicInfo
                    invoiceImp={invoice}
                    approvalProcessImp={approvalProcess}
                    approvalStepsImp={approvalSteps}
                    approvalActiveStepImp={approvalActiveStep}
                  />
                );
                setHeaderTitle("Basic Info");
                break;
              case "payments":
                selectedComponent = (
                  <IncomingInvoicePayments
                    invoiceID={invoice.ID}
                    history={history}
                  />
                );
                setHeaderTitle("Payments");
                break;
              case "attachments":
                selectedComponent = (
                  <Attachments docType="INVR" docID={invoice.ID} />
                );
                setHeaderTitle("Attachments");
                break;
              case "notes":
                selectedComponent = <Notes docType="INVR" docID={invoice.ID} />;
                setHeaderTitle("Notes");
                break;
              default:
                selectedComponent = (
                  <IncomingInvoiceBasicInfo
                    invoiceImp={invoice}
                    approvalProcessImp={approvalProcess}
                    approvalStepsImp={approvalSteps}
                    approvalActiveStepImp={approvalActiveStep}
                  />
                );
                setHeaderTitle("Basic Info");
                break;
            }
            setComponent(selectedComponent);
          }}
          defaultSelected={defaultSelected}
        />
      </ContentLayout>
    </React.Fragment>
  );

  async function getIncomingInvoiceData(invoiceID) {
    const response = await getIncomingInvoiceDetail(invoiceID);
    const { data } = response.data;
    const componentTmp = (
      <IncomingInvoiceBasicInfo
        invoiceImp={data.incomingInvoice}
        approvalProcessImp={data.approvalProcess}
        approvalStepsImp={
          data.incomingInvoice.approvalProcess.approval.approvalValue
        }
        approvalActiveStepImp={data.incomingInvoice.approvalProcess.level}
      />
    );
    setInvoice(data.incomingInvoice);
    setApprovalProcess(data.approvalProcess);
    setApprovalSteps(
      data.incomingInvoice.approvalProcess.approval.approvalValue
    );
    setApprovalActiveStep(data.incomingInvoice.approvalProcess.level);
    setComponent(componentTmp);
  }
}

export default IncomingInvoiceDetail;
